/**
 * Split out of PageviewTracker.tsx so that file stays component-only
 * (react-refresh/only-export-components).
 */
import { matchPath } from "react-router-dom";

// Route patterns that carry a resource ID segment. Kept in sync by hand with
// frontend/src/app/AppRoutes.tsx — a stale entry here just means that one
// route's pageview falls back to reporting the raw path instead of the
// pattern below, not a crash.
const DYNAMIC_ROUTE_PATTERNS = [
  "/results/:auditId",
  "/reports/:id",
  "/internal/pipeline-transparency/:auditId",
  "/monitoring/:id",
];

// Static sibling routes that a DYNAMIC_ROUTE_PATTERNS entry would otherwise
// swallow — AppRoutes.tsx declares "/monitoring/new" as its own static
// route alongside "/monitoring/:id"; matchPath alone can't tell them apart
// since it has no notion of React Router's declaration-order precedence.
const STATIC_ROUTE_EXCEPTIONS = ["/monitoring/new"];

/**
 * Replace a resource ID in the pathname with its route pattern (e.g.
 * "/results/abc-123" -> "/results/:auditId") before sending to PostHog, so
 * page views group by route instead of fragmenting per audit/report/monitor
 * — and the raw ID never leaves the app, matching the `$current_url` denial
 * in posthog.ts (same "no identifiers in analytics URLs" posture).
 */
export function normalizeAnalyticsPath(pathname: string): string {
  if (STATIC_ROUTE_EXCEPTIONS.includes(pathname)) return pathname;
  for (const pattern of DYNAMIC_ROUTE_PATTERNS) {
    if (matchPath(pattern, pathname)) return pattern;
  }
  return pathname;
}
